import Vue from 'vue';
import Router from 'vue-router';
import SupplyChain from './SupplyChain.vue';
import AddProduct from './AddProduct.vue';
import OrderList from './OrderList.vue';
import Brokerage from './Brokerage.vue';
import Charge from './Charge.vue';
import Management from './Management.vue';
import OrderDetail from './OrderDetail.vue';
import Report from './Report.vue';
import UserInfo from './UserInfo.vue';
import GoodsSetup from './GoodsSetup'
import GoodsSetups from './GoodsSetups'
import SetPosition from './SetPosition.vue';
import C from '../Container'

import Login from './Login'//登录
import InstallationCompany from './InstallationCompany'
import InstallationList from './InstallationList'
import InstallTeamList from './InstallTeamList'
import PaigongLists from './PaigongLists'//派工列表
import LogisticsCompany from './LogisticsCompany'
import DriverList from './DriverList'
import Printing from './Printing'
import Printing1 from './Printing1'
import Cangku from './Cangku'
import Cangku2 from './Cangku2'
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/Login'
        },
        {
            path: '/Printing',
            name: 'Printing',
            component: Printing
        },
        {
            path: '/Printing1',
            name: 'Printing1',
            component: Printing1
        },
        {
            path: '/C',
            name: 'C',
            component: C,
            children: [
                {
                    path: '/InstallationCompany',
                    name: 'InstallationCompany',
                    component: InstallationCompany
                }, //安装公司
                {
                    path: '/OrderList',
                    name: 'OrderList',
                    component: OrderList//订单列表
                },
                {
                    path: '/InstallationList',
                    name: 'InstallationList',
                    component: InstallationList//安装列表
                },
                {
                    path: '/Cangku',
                    name: 'Cangku',
                    component: Cangku//仓库待发货列表
                },
                {
                    path: '/Cangku2',
                    name: 'Cangku2',
                    component: Cangku2//仓库已发货列表
                },
                {
                    path: '/InstallTeamList',
                    name: 'InstallTeamList',
                    component: InstallTeamList//安装队列表
                },
                {
                    path: '/LogisticsCompany',
                    name: 'LogisticsCompany',
                    component: LogisticsCompany//
                },
                {
                    path: '/PaigongLists',
                    name: 'PaigongLists',
                    component: PaigongLists//
                },
                {
                    path: '/DriverList',
                    name: 'DriverList',
                    component: DriverList
                },
                {
                    path: '/OrderList/:id',
                    name: 'OrderDetail',
                    component: OrderDetail
                },
                // {
                //     path: '/SupplyChain',
                //     name: 'SupplyChain',
                //     component: SupplyChain
                // }, {
                //     path: '/SupplyChain/AddProduct',
                //     name: 'AddProduct',
                //     component: AddProduct
                // }, {
                //     path: '/Brokerage',
                //     name: 'Brokerage',
                //     component: Brokerage
                // }, {
                //     path: '/Charge',
                //     name: 'Charge',
                //     component: Charge
                // }, {
                //     path: '/Management',
                //     name: 'Management',
                //     component: Management
                // }, {
                //     path: '/Report',
                //     name: 'Report',
                //     component: Report
                // }, {
                //     path: '/UserInfo',
                //     name: 'UserInfo',
                //     component: UserInfo
                // }, {
                //     path: '/SetPosition',
                //     name: 'SetPosition',
                //     component: SetPosition
                // },
                // {
                //     path: '/GoodsSetup',
                //     name: 'GoodsSetup',
                //     component: GoodsSetup
                // },
                // {
                //     path: '/GoodsSetups',
                //     name: 'GoodsSetups',
                //     component: GoodsSetups
                // }
                ]
        },
        {
            path: '/Login',
            name: 'Login',
            component: Login
        }

    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js